import { create, tsx } from '@dojo/framework/core/vdom';
import * as css from './HeroBackground.m.css';

interface Background {
	bg: any;
	left?: any;
	right?: any;
}

const backgrounds = {
	level0PurpleBlue: {
		bg: require('../assets/images/home/home-background.svg')
	},
	level1RedOrange: {
		bg: require('../assets/images/header-section-backgrounds/level-1_red-orange/bg.svg'),
		left: require('../assets/images/header-section-backgrounds/level-1_red-orange/left.svg'),
		right: require('../assets/images/header-section-backgrounds/level-1_red-orange/right.svg')
	},
	level1PurpleTeal: {
		bg: require('../assets/images/header-section-backgrounds/level-1_purple-teal/bg.svg'),
		left: require('../assets/images/header-section-backgrounds/level-1_purple-teal/left.svg'),
		right: require('../assets/images/header-section-backgrounds/level-1_purple-teal/right.svg')
	},
	level1BluePurple: {
		bg: require('../assets/images/header-section-backgrounds/level-1_blue-purple/bg.svg'),
		left: require('../assets/images/header-section-backgrounds/level-1_blue-purple/left.svg'),
		right: require('../assets/images/header-section-backgrounds/level-1_blue-purple/right.svg')
	},
	level1BlueGreen: {
		bg: require('../assets/images/header-section-backgrounds/level-1_blue-green/bg.svg'),
		left: require('../assets/images/header-section-backgrounds/level-1_blue-green/left.svg'),
		right: require('../assets/images/header-section-backgrounds/level-1_blue-green/right.svg')
	},
	level2RedOrange: {
		bg: require('../assets/images/header-section-backgrounds/level-2_red-orange/bg.svg'),
		left: require('../assets/images/header-section-backgrounds/level-2_red-orange/left.svg'),
		right: require('../assets/images/header-section-backgrounds/level-2_red-orange/right.svg')
	},
	level2PurpleTeal: {
		bg: require('../assets/images/header-section-backgrounds/level-2_purple-teal/bg.svg'),
		left: require('../assets/images/header-section-backgrounds/level-2_purple-teal/left.svg'),
		right: require('../assets/images/header-section-backgrounds/level-2_purple-teal/right.svg')
	},
	level2BluePurple: {
		bg: require('../assets/images/header-section-backgrounds/level-2_blue-purple/bg.svg'),
		left: require('../assets/images/header-section-backgrounds/level-2_blue-purple/left.svg'),
		right: require('../assets/images/header-section-backgrounds/level-2_blue-purple/right.svg')
	},
	level2BlueGreen: {
		bg: require('../assets/images/header-section-backgrounds/level-2_blue-green/bg.svg'),
		left: require('../assets/images/header-section-backgrounds/level-2_blue-green/left.svg'),
		right: require('../assets/images/header-section-backgrounds/level-2_blue-green/right.svg')
	},
	level3Yellow: {
		bg: require('../assets/images/header-section-backgrounds/level-3_yellow/bg_with-white.svg')
	},
	level3Red: {
		bg: require('../assets/images/header-section-backgrounds/level-3_red/bg_with-white.svg')
	},
	level3Purple: {
		bg: require('../assets/images/header-section-backgrounds/level-3_purple/bg_with-white.svg')
	},
	level3Pink: {
		bg: require('../assets/images/header-section-backgrounds/level-3_pink/bg_with-white.svg')
	},
	level3Green: {
		bg: require('../assets/images/header-section-backgrounds/level-3_green/bg_with-white.svg')
	},
	level3Blue: {
		bg: require('../assets/images/header-section-backgrounds/level-3_blue/bg_with-white.svg')
	}
} as const;

export type BackgroundKey = keyof typeof backgrounds;

export interface HeroBackgroundProperties {
	background: BackgroundKey;
}

const factory = create().properties<HeroBackgroundProperties>();

export const HeroBackground = factory(function HeroBackground({ properties }) {
	const { background: type } = properties();
	const background: Background | undefined = type ? backgrounds[type] : undefined;

	let levelCss = undefined;
	if (type?.indexOf('level0') !== -1) {
		levelCss = css.level0;
	} else if (type?.indexOf('level1') !== -1) {
		levelCss = css.level1;
	} else if (type?.indexOf('level2') !== -1) {
		levelCss = css.level2;
	} else if (type?.indexOf('level3') !== -1) {
		levelCss = css.level3;
	}

	return (
		<virtual>
			{background && (
				<svg classes={[css.bg, levelCss]}>
					<image
						preserveAspectRatio="none"
						classes={[levelCss, css.bgImage]}
						href={background.bg}
						alt=""
					/>
				</svg>
			)}
			{background?.left && (
				<img classes={[css.left, levelCss]} src={background.left} alt="" />
			)}
			{background?.right && (
				<img classes={[css.right, levelCss]} src={background.right} alt="" />
			)}
		</virtual>
	);
});

export default HeroBackground;
